import WorkerDetails from './WorkerDetails';

export default WorkerDetails;
